const settings = {
    galleryPath: "/pictures/",
    cardPath:"/images/cards/",
    editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ]
}

settings.install = function (Vue) {
    Vue.prototype.$settings = settings;
}

export default settings;